import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiState } from '@/models/generics';
import { TWishlistProduct } from '@/services/wishlist/models/wishlist';

export interface IWishlistStore {
  loading: boolean;
  getWishlistApiState: ApiState;
  wishlists: TWishlistProduct[];
  wishlistedProductsMap: Record<number, TWishlistProduct>;
  error: boolean;
}

// Initial state
const initialState: IWishlistStore = {
  loading: false,
  getWishlistApiState: ApiState.IDLE,
  wishlists: [],
  error: false,
  wishlistedProductsMap: {}
};

// Create the slice
const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {
    wishlistLoading: (state) => {
      state.loading = true;
      state.getWishlistApiState = ApiState.LOADING;
    },
    wishlistSuccess: (state, action: PayloadAction<{ 
      wishlistedProducts: TWishlistProduct[], 
      wishlistedProductsMap: Record<number, TWishlistProduct> 
    }>) => {
      state.loading = false;
      state.getWishlistApiState = ApiState.SUCCESS;
      state.wishlists = action.payload.wishlistedProducts;
      state.wishlistedProductsMap = action.payload.wishlistedProductsMap;
    },
    wishlistError: (state) => {
      state.loading = false;
      state.getWishlistApiState = ApiState.FAILED;
      state.error = true;
    }
  }
});

export const { wishlistLoading, wishlistSuccess, wishlistError } = wishlistSlice.actions;
export default wishlistSlice.reducer;